import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import FiltersRow from './filtersRow';

const enhance = compose(
  withTranslation(['common', 'project']),
);
export default enhance(FiltersRow);
